import { render, staticRenderFns } from "./FinalExamProtocolsDaily.vue?vue&type=template&id=5bdb1218"
import script from "./FinalExamProtocolsDaily.vue?vue&type=script&lang=js"
export * from "./FinalExamProtocolsDaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports